// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_0fd55ca845--overlay--WG6hm"};